import { Button } from "@windmill/react-ui";
import React, { useState } from "react";
import { notifyError } from "../../utils/toast";
import ProgressBar from "../progressbar/ProgressBar";
import OnBoardingContainer from "./onBoardingContainer";
import Logo from "../logo/Logo";
import BackButton from "./BackButton";

// Department options for selection
const departmentOptions = [
  { id: "sales", name: "Sales", icon: "📊" },
  { id: "marketing", name: "Marketing", icon: "📣" },
  { id: "finance", name: "Finance", icon: "💰" },
  { id: "hr", name: "Human Resources", icon: "👥" },
  { id: "operations", name: "Operations", icon: "⚙️" },
  { id: "it", name: "IT", icon: "💻" },
  { id: "customer_service", name: "Customer Service", icon: "🤝" },
  { id: "product", name: "Product", icon: "📦" },
  { id: "research", name: "Research & Development", icon: "🔬" },
  { id: "legal", name: "Legal", icon: "⚖️" },
  { id: "procurement", name: "Procurement", icon: "🛒" },
  { id: "logistics", name: "Logistics", icon: "🚚" },
];

export default function DepartmentSelection({
  setStep,
  setStoreData,
  storeData,
}) {
  const [selectedDepartments, setSelectedDepartments] = useState(
    storeData.departments || []
  );

  const handleDepartmentToggle = (departmentId) => {
    if (selectedDepartments.includes(departmentId)) {
      setSelectedDepartments(
        selectedDepartments.filter((id) => id !== departmentId)
      );
    } else {
      setSelectedDepartments([...selectedDepartments, departmentId]);
    }

    // Update parent state
    setStoreData((prev) => ({
      ...prev,
      departments: selectedDepartments.includes(departmentId)
        ? selectedDepartments.filter((id) => id !== departmentId)
        : [...selectedDepartments, departmentId],
    }));
  };

  return (
    <div className="h-screen bg-green-50">
      <div className="max-w-4xl mx-auto py-12">
        <OnBoardingContainer>
          <div className="text-left p-6 lg:p-8 lg:px-10 pt-6">
          <Logo />
            <ProgressBar level={"70%"} />

            <div>
              <p className="text-lg font-medium mt-6">
                Which departments are part of your company, team, or
                organization?
              </p>
              <p className="text-sm mt-1">
                Select all applicable departments. This helps us tailor reports
                to fit your needs.
              </p>

              <div className="mt-6">
                <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-4">
                  {departmentOptions.map((department) => (
                    <div
                      key={department.id}
                      onClick={() => handleDepartmentToggle(department.id)}
                      className={`cursor-pointer border ${
                        selectedDepartments.includes(department.id)
                          ? "border-green-500 bg-green-50"
                          : "border-gray-200"
                      } rounded-lg p-4 transition-all hover:shadow-md`}
                    >
                      <div className="flex items-center">
                        <div className="text-2xl mr-3">{department.icon}</div>
                        <div>
                          <p className="font-medium">{department.name}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="flex justify-between py-4 pb-0 bottom-0 w-full px-4 lg:px-0 mt-8">
              <BackButton setStep={setStep} />
              <Button
                onClick={() => {
                  if (selectedDepartments.length === 0) {
                    notifyError("Please select at least one department");
                    return;
                  }
                  setStep((prev) => prev + 1);
                }}
                className="px-12"
              >
                Continue
              </Button>
            </div>
          </div>
        </OnBoardingContainer>
      </div>
    </div>
  );
}
